import type * as React from 'react';
import { del } from '@Domain/Api';
import assignmentScopePath from '@Application/Ai/AiConfiguration/Assignments/assignmentScopePath';
import modelAssignmentCleared, {
	type ModelAssignmentClearedAction,
} from '@Application/Ai/AiConfiguration/Assignments/Actions/modelAssignmentCleared';
import modelAssignmentClearFailed, {
	type ModelAssignmentClearFailedAction,
} from '@Application/Ai/AiConfiguration/Assignments/Actions/modelAssignmentClearFailed';
import type ClearModelAssignment from '@Application/Ai/AiConfiguration/Assignments/Commands/ClearModelAssignment';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = ModelAssignmentClearedAction | ModelAssignmentClearFailedAction;

export default (command: ClearModelAssignment) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${parameters.api.host}/api/${assignmentScopePath(command.scope)}/${command.usage}`,
			);

			const action = modelAssignmentCleared({ usage: command.usage }, command.scope);
			dispatch(action);
			return action;
		} catch (error) {
			const action = modelAssignmentClearFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
